// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ManageProjectsBudgetsStepQueryVariables = Types.Exact<{
  bcrId: Types.Scalars['ID']['input'];
}>;


export type ManageProjectsBudgetsStepQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, version: string, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus }, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, potentialProjectItems: Array<{ __typename?: 'PotentialProjectItem', totalCostInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, allCommittedCostInCents: number, revisedApprovedBudgetInCents: number, itemTemplateItem?:
          | { __typename?: 'ItemTemplateItemVersion', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
          | { __typename?: 'ItemTemplateItem', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
          | { __typename?: 'TakeoffLineItem', id: string, parent:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             }
          | { __typename?: 'TakeoffLineItemVersion', id: string, parent:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             }
         | null | undefined, bidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } } | null | undefined, project:
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
         } }> } };

export type AssignWorkToBidContractsMutationVariables = Types.Exact<{
  input: Array<Types.AssignWorkToBidContractInput> | Types.AssignWorkToBidContractInput;
}>;


export type AssignWorkToBidContractsMutation = { __typename?: 'Mutation', assignWorkToBidContract: Array<{ __typename?: 'ChangeEvent', id: string }> };

export type ManageProjectsBudgets_BidContractRevisionFragment = { __typename?: 'BidContractRevision', id: string, version: string, status: { __typename?: 'BidContractRevisionStatusDetail', code: Types.BidContractRevisionStatus }, bidContract: { __typename?: 'BidContract', id: string, isInternalEstimate: boolean, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, potentialProjectItems: Array<{ __typename?: 'PotentialProjectItem', totalCostInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, allCommittedCostInCents: number, revisedApprovedBudgetInCents: number, itemTemplateItem?:
        | { __typename?: 'ItemTemplateItemVersion', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'ItemTemplateItem', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
        | { __typename?: 'TakeoffLineItem', id: string, parent:
            | { __typename?: 'ReadyPlan', id: string, displayName: string }
            | { __typename?: 'PlanPackage', id: string, displayName: string }
            | { __typename?: 'DesignPackage', id: string, displayName: string }
            | { __typename?: 'ProductOffering', id: string, displayName: string }
           }
        | { __typename?: 'TakeoffLineItemVersion', id: string, parent:
            | { __typename?: 'ReadyPlan', id: string, displayName: string }
            | { __typename?: 'PlanPackage', id: string, displayName: string }
            | { __typename?: 'DesignPackage', id: string, displayName: string }
            | { __typename?: 'ProductOffering', id: string, displayName: string }
           }
       | null | undefined, bidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } } | null | undefined, project:
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
       } }> };

export type ManageProjectsBudgets_PotentialProjectItemFragment = { __typename?: 'PotentialProjectItem', totalCostInCents: number, projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, allCommittedCostInCents: number, revisedApprovedBudgetInCents: number, itemTemplateItem?:
      | { __typename?: 'ItemTemplateItemVersion', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
      | { __typename?: 'ItemTemplateItem', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
      | { __typename?: 'TakeoffLineItem', id: string, parent:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         }
      | { __typename?: 'TakeoffLineItemVersion', id: string, parent:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         }
     | null | undefined, bidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } } | null | undefined, project:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     } };

export type ManageProjectsBudgets_ProjectItemFragment = { __typename?: 'ProjectItem', id: string, displayName: string, totalCostInCents: number, allCommittedCostInCents: number, revisedApprovedBudgetInCents: number, itemTemplateItem?:
    | { __typename?: 'ItemTemplateItemVersion', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
    | { __typename?: 'ItemTemplateItem', id: string, parent: { __typename?: 'ItemTemplate', id: string, displayName: string } }
    | { __typename?: 'TakeoffLineItem', id: string, parent:
        | { __typename?: 'ReadyPlan', id: string, displayName: string }
        | { __typename?: 'PlanPackage', id: string, displayName: string }
        | { __typename?: 'DesignPackage', id: string, displayName: string }
        | { __typename?: 'ProductOffering', id: string, displayName: string }
       }
    | { __typename?: 'TakeoffLineItemVersion', id: string, parent:
        | { __typename?: 'ReadyPlan', id: string, displayName: string }
        | { __typename?: 'PlanPackage', id: string, displayName: string }
        | { __typename?: 'DesignPackage', id: string, displayName: string }
        | { __typename?: 'ProductOffering', id: string, displayName: string }
       }
   | null | undefined, bidContractLineItem?: { __typename?: 'BidContractLineItem', id: string, revision: { __typename?: 'BidContractRevision', id: string, version: string, bidContract: { __typename?: 'BidContract', id: string, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined } } } | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string }
    | { __typename?: 'Community', id: string, name: string }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
   };

export const ManageProjectsBudgets_ProjectItemFragmentDoc = gql`
    fragment ManageProjectsBudgets_ProjectItem on ProjectItem {
  id
  displayName
  totalCostInCents
  allCommittedCostInCents
  revisedApprovedBudgetInCents
  itemTemplateItem {
    id
    parent {
      id
      displayName
    }
  }
  bidContractLineItem {
    id
    revision {
      id
      version
      bidContract {
        id
        tradePartner {
          ...Named
        }
      }
    }
  }
  project {
    ...Named
  }
}
    ${NamedFragmentDoc}`;
export const ManageProjectsBudgets_PotentialProjectItemFragmentDoc = gql`
    fragment ManageProjectsBudgets_PotentialProjectItem on PotentialProjectItem {
  projectItem {
    ...ManageProjectsBudgets_ProjectItem
  }
  totalCostInCents
}
    ${ManageProjectsBudgets_ProjectItemFragmentDoc}`;
export const ManageProjectsBudgets_BidContractRevisionFragmentDoc = gql`
    fragment ManageProjectsBudgets_BidContractRevision on BidContractRevision {
  id
  version
  status {
    code
  }
  bidContract {
    id
    tradePartner {
      ...Named
    }
    isInternalEstimate
  }
  potentialProjectItems {
    ...ManageProjectsBudgets_PotentialProjectItem
  }
}
    ${NamedFragmentDoc}
${ManageProjectsBudgets_PotentialProjectItemFragmentDoc}`;
export const ManageProjectsBudgetsStepDocument = gql`
    query ManageProjectsBudgetsStep($bcrId: ID!) {
  bidContractRevision(id: $bcrId) {
    ...ManageProjectsBudgets_BidContractRevision
  }
}
    ${ManageProjectsBudgets_BidContractRevisionFragmentDoc}`;

/**
 * __useManageProjectsBudgetsStepQuery__
 *
 * To run a query within a React component, call `useManageProjectsBudgetsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageProjectsBudgetsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageProjectsBudgetsStepQuery({
 *   variables: {
 *      bcrId: // value for 'bcrId'
 *   },
 * });
 */
export function useManageProjectsBudgetsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables> & ({ variables: ManageProjectsBudgetsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>(ManageProjectsBudgetsStepDocument, options);
      }
export function useManageProjectsBudgetsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>(ManageProjectsBudgetsStepDocument, options);
        }
// @ts-ignore
export function useManageProjectsBudgetsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>;
export function useManageProjectsBudgetsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ManageProjectsBudgetsStepQuery | undefined, ManageProjectsBudgetsStepQueryVariables>;
export function useManageProjectsBudgetsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>(ManageProjectsBudgetsStepDocument, options);
        }
export type ManageProjectsBudgetsStepQueryHookResult = ReturnType<typeof useManageProjectsBudgetsStepQuery>;
export type ManageProjectsBudgetsStepLazyQueryHookResult = ReturnType<typeof useManageProjectsBudgetsStepLazyQuery>;
export type ManageProjectsBudgetsStepSuspenseQueryHookResult = ReturnType<typeof useManageProjectsBudgetsStepSuspenseQuery>;
export type ManageProjectsBudgetsStepQueryResult = ApolloReactCommon.QueryResult<ManageProjectsBudgetsStepQuery, ManageProjectsBudgetsStepQueryVariables>;
export const AssignWorkToBidContractsDocument = gql`
    mutation AssignWorkToBidContracts($input: [AssignWorkToBidContractInput!]!) {
  assignWorkToBidContract(input: $input) {
    id
  }
}
    `;

/**
 * __useAssignWorkToBidContractsMutation__
 *
 * To run a mutation, you first call `useAssignWorkToBidContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignWorkToBidContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignWorkToBidContractsMutation, { data, loading, error }] = useAssignWorkToBidContractsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignWorkToBidContractsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignWorkToBidContractsMutation, AssignWorkToBidContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignWorkToBidContractsMutation, AssignWorkToBidContractsMutationVariables>(AssignWorkToBidContractsDocument, options);
      }
export type AssignWorkToBidContractsMutationHookResult = ReturnType<typeof useAssignWorkToBidContractsMutation>;
export type AssignWorkToBidContractsMutationResult = ApolloReactCommon.MutationResult<AssignWorkToBidContractsMutation>;